import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { NavigationComponent, HeaderComponent, SvgIconComponent, FooterComponent } from './components';

@NgModule({
  declarations: [
    NavigationComponent,
    HeaderComponent,
    SvgIconComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    NavigationComponent,
    HeaderComponent,
    SvgIconComponent,
    FooterComponent
  ]
})
export class SharedModule { }
